export default __webpack_public_path__ + "static/media/Frame4.7448020a.png";